import billingController from './billing.controller';
import stInvoicesList from './invoicesList.component';
import Plan from './plan.model';
import Seat from './seat.model';
import stSeatsList from './seatsList.component';

export default angular
  .module('st.Billing', ['st.Core', 'angular-cache', 'stripe.checkout'])
  .factory('Plan', Plan)
  .factory('Seat', Seat)
  .controller('billingController', billingController)
  .component('stInvoicesList', stInvoicesList)
  .component('stSeatsList', stSeatsList)
  .service(
    'billingService',
    ($http, $rootScope, CacheFactory, dataService, Plan, Seat, BILLING) => {
      const buildPlans = (plans) => {
        if (!_.isArray(plans)) {
          return Plan.build(plans);
        }
        return _.map(plans || [], (plan) => Plan.build(plan));
      };

      const buildSeats = (seats) => {
        if (!_.isArray(seats)) {
          return Seat.build(seats);
        }
        return _.map(seats || [], (seat) => Seat.build(seat));
      };

      let cache;
      if (!CacheFactory.get(BILLING.CACHE.NAME)) {
        cache = CacheFactory(BILLING.CACHE.NAME, BILLING.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || BILLING.CACHE.NAME,
          params
        });

      return {
        clearCache: () => cache.removeAll(),
        change: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, BILLING.API.CHANGE, {
            params
          }),
        charges: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, BILLING.API.CHARGES, {
            params
          }),
        invoices: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, BILLING.API.INVOICES, {
            params
          }),
        getPlans: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getPlans'),
            false,
            buildPlans,
            $http.get,
            BILLING.API.PLANS,
            { params: {} }
          ),
        getSeats: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getSeats'),
            false,
            buildSeats,
            $http.get,
            BILLING.API.SEATS,
            { params }
          ),
        getBillables: (params) =>
          dataService
            .apiRequest(null, null, true, null, $http.post, BILLING.API.BILLABLES, {
              params,
              __requestConfiguration: {
                responseType: 'arraybuffer',
                transformResponse: (response) => ({
                  response: response
                    ? new Blob([response], { type: 'application/octet-stream' })
                    : null
                })
              }
            })
            .then((data) => {
              saveAs(data.response, 'billables.xlsx');
            }),
        purchaseSignatures: (params) =>
          dataService.apiRequest(
            null,
            null,
            true,
            null,
            $http.get,
            BILLING.API.PURCHASE_SIGNATURES,
            {
              params
            }
          ),
        purchaseSMS: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, BILLING.API.PURCHASE_SMS, {
            params
          }),
        purchaseWebloanQ: (params) =>
          dataService.apiRequest(
            null,
            null,
            true,
            null,
            $http.get,
            BILLING.API.PURCHASE_WEBLOANQ,
            {
              params
            }
          ),
        purchaseWebloanQUnsubscribe: (params) =>
          dataService.apiRequest(
            null,
            null,
            true,
            null,
            $http.get,
            BILLING.API.PURCHASE_WEBLOANQ_UNSUBSCRIBE,
            {
              params
            }
          ),
        purchaseIdSmart: (params) =>
          dataService.apiRequest(
            null,
            null,
            true,
            null,
            $http.get,
            BILLING.API.PURCHASE_ID_SMART,
            {
              params
            }
          ),
        purchasePpsr: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, BILLING.API.PURCHASE_PPSR, {
            params
          }),
        subscribe: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, BILLING.API.SUBSCRIBE, {
            params
          }),
        unsubscribe: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, BILLING.API.UNSUBSCRIBE, {
            params
          }),
        upcoming: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, BILLING.API.UPCOMING, {
            params
          }),
        update: (params) =>
          dataService.apiRequest(null, null, true, null, $http.post, BILLING.API.UPDATE, {
            params
          })
      };
    }
  )
  .constant('BILLING', {
    API: {
      BILLABLES: '/api/v1/billing/export-billables/',
      CHANGE: '/api/v1/billing/change/',
      CHARGES: '/api/v1/billing/charges/',
      INVOICES: '/api/v1/billing/invoices/',
      PLANS: '/api/v1/billing/plans/',
      PURCHASE_SIGNATURES: '/api/v1/billing/purchase-signatures/',
      PURCHASE_SMS: '/api/v1/billing/purchase-sms/',
      PURCHASE_WEBLOANQ: '/api/v1/billing/purchase-webloanq/',
      PURCHASE_WEBLOANQ_UNSUBSCRIBE: '/api/v1/billing/purchase-webloanq-unsubscribe/',
      PURCHASE_ID_SMART: '/api/v1/billing/purchase-id-smart/',
      PURCHASE_PPSR: '/api/v1/billing/purchase-ppsr/',
      SEATS: '/api/v1/billing/seats/',
      SUBSCRIBE: '/api/v1/billing/subscribe/',
      UNSUBSCRIBE: '/api/v1/billing/unsubscribe/',
      UPCOMING: '/api/v1/billing/upcoming/',
      UPDATE: '/api/v1/billing/update/'
    },
    PLANS: ['SUBCRM', 'SUBPROCESSOR', 'PROMNT', 'PROANN', 'BUSMNT', 'BUSANN'],
    PLAN_BROKERS: {
      id: 'SUBPROCESSOR',
      shorthand: 'SUBPROCESSOR',
      name: 'Mortgage Brokers',
      type: 'Monthly',
      interval: 'Month',
      value: 70.0
    },
    PLAN_PARTNERS: {
      id: 'PARTNERS',
      shorthand: 'PARTNERS',
      name: 'Partners Portal',
      type: 'Monthly',
      interval: 'Month',
      value: 4.99
    },
    PLAN_PHONES: {
      id: 'PHONES',
      shorthand: 'PHONES',
      name: 'Rental Phones',
      type: 'Monthly',
      interval: 'Month',
      value: 29.99
    },
    PLAN_WEBLOANQ: {
      id: 'price_1Jrx61GDITq5oTFpoY54Uxgw',
      shorthand: 'WEBLOANQ',
      name: 'WebloanQ',
      type: 'Monthly',
      interval: 'Month',
      value: 24.99
    },
    BILLING_DETAILS: {
      TAX: 10.0
    },
    CACHE: {
      NAME: 'billingCache',
      STORE: {
        TTL: 5 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 5 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  });
